"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HVAC = exports.HVACModeObject = exports.HVACMode = void 0;
const Component_1 = require("./Component");
var HVACMode;
(function (HVACMode) {
    HVACMode["Cool"] = "cool";
    HVACMode["Heat"] = "heat";
    HVACMode["FanOnly"] = "fanOnly";
    HVACMode["Off"] = "off";
})(HVACMode = exports.HVACMode || (exports.HVACMode = {}));
exports.HVACModeObject = {
    [HVACMode.Cool]: HVACMode.Cool,
    [HVACMode.Heat]: HVACMode.Heat,
    [HVACMode.FanOnly]: HVACMode.FanOnly,
    [HVACMode.Off]: HVACMode.Off,
};
class HVAC extends Component_1.Component {
    static setToMode({ values }) {
        const { mode } = values;
        return {
            intended: {
                s: { mode },
            },
            futureReported: {
                s: { mode },
            },
        };
    }
    static setToTemp({ values }) {
        const { setTemp } = values;
        return {
            intended: {
                s: { setTemp },
            },
            futureReported: {
                s: { setTemp },
            },
        };
    }
    static setToFanSpeed({ values }) {
        const { fanSpeed } = values;
        return {
            intended: {
                s: { fanSpeed },
            },
            futureReported: {
                s: { fanSpeed },
            },
        };
    }
    static setFanToAuto() {
        return {
            intended: {
                s: { fanSpeed: 'auto' },
            },
            futureReported: {
                s: { fanSpeed: 'auto' },
            },
        };
    }
    static toggleFanAuto({ currentState }) {
        if (!currentState) {
            throw new Error('currentState was not provided.');
        }
        if (currentState.fanSpeed === 'auto') {
            return HVAC.setToFanSpeed({ values: { fanSpeed: 1 } });
        }
        return HVAC.setFanToAuto();
    }
    static turnOff() {
        return {
            intended: {
                s: { mode: 'off' },
            },
            futureReported: {
                s: { mode: 'off' },
            },
        };
    }
}
exports.HVAC = HVAC;
//# sourceMappingURL=HVAC.js.map